module.exports = __webpack_public_path__ + "media/newstyle/images/info-red-210bffb5729edaadf38c87b7f98a0b17.svg";